import { useLayoutEffect } from 'react';

export default function SnapPage({ children }) {
  useLayoutEffect(() => {
    document.documentElement.classList.add('snap-mode');
    return () => document.documentElement.classList.remove('snap-mode');
  }, []);
  return <>{children}</>;
}
